// Commission rates moved OFF team_roster into the leadership-only
// `team_roster_comp` table (Sep 9, 2026). team_roster.commission_rate is
// neutralized to the 0.10 base for every row (drop after ~Oct 9, 2026) — the
// real rates reach the client ONLY through the `visible_commission_rates()`
// SECURITY DEFINER RPC, which returns exactly what the caller may see:
//   leadership + finance → everyone · ASM → self + downline · TL → self +
//   team · anyone else → self only.
//
// Usage: every fetch site that builds a members map for money math adds
// `supabase.rpc("visible_commission_rates")` to its Promise.all, then calls
// `mergeRates(members, ratesMapFromRows(data))` BEFORE any groupByPerson /
// dealRateInfo run. rmRateFor() keeps reading member.commission_rate — a rate
// the viewer can't see merges as null and falls back to the 10% base, which
// only ever affects lines that viewer's surfaces don't display.

export function ratesMapFromRows(rows: unknown): Map<string, number> {
  const map = new Map<string, number>();
  if (!Array.isArray(rows)) return map;
  for (const r of rows as Array<{ member_id?: string; commission_rate?: number | string }>) {
    // PostgREST returns numerics as strings — always Number() them.
    const n = Number(r?.commission_rate);
    if (r?.member_id && Number.isFinite(n)) map.set(r.member_id, n);
  }
  return map;
}

/**
 * Overwrite commission_rate on every member with the RPC-visible value (null
 * when hidden). Overwriting — not filling gaps — matters: the team_roster
 * column still exists but carries only the neutralized 0.10, so the RPC value
 * must always win. Accepts the array or Record shape the fetch sites use.
 */
export function mergeRates<T extends { id: string; commission_rate?: number | null }>(
  members: T[] | Record<string, T>,
  rates: Map<string, number>,
): void {
  const list = Array.isArray(members) ? members : Object.values(members);
  for (const m of list) m.commission_rate = rates.get(m.id) ?? null;
}
